import React, { useState } from 'react';
import { Button } from 'antd';
import { ShareAltOutlined } from '@ant-design/icons';
import { Dictionary } from '@onaio/utils/dist/types/types';
import ShareModal from './ShareModal';

interface PermissionDisplay {
  id: string;
  email?: string;
  name?: string;
  type: 'user' | 'group';
  role: 'admin' | 'edit' | 'view';
  image?: string;
}
interface ShareOptionsProps {
  post: Dictionary;
  user: Dictionary;
  className?: string;
}

const ShareOptions: React.FC<ShareOptionsProps> = ({ post, user, className }) => {
  const [shareModalVisible, setShareModalVisible] = useState(false);
  const userPermissionObject: PermissionDisplay = {
    id: user.uuid,
    email: user.email,
    name: user.name,
    type: 'user',
    role: "admin",
    image: user.image,
  }

  return (
    <>
      <Button 
        icon={<ShareAltOutlined />} 
        onClick={() => setShareModalVisible(true)}
        className={className}
      />
      
      <ShareModal
        user={userPermissionObject}
        open={shareModalVisible}
        post={post}
        onCancel={() => setShareModalVisible(false)}
      />
    </>
  );
};

export { ShareOptions }; 